export const support_href = 'support@reactrino.com';
export const support_title = 'support@reactrino.com';
export const login_href = 'https://console.reactrino.com/';
export const school_href = 'https://clip.school/r/reactrino';
export let privacy_href = '';
export let terms_href = '';
